import { createSelector } from 'reselect'

const selectData = (state) => state.settings.simulator.self.data
const selectLoader = (state) => state.settings.simulator.self.loader
const selectError = (state) => state.settings.simulator.self.error
const selectRecipientList = (state) => state.settings.simulator.self.recipientList
const selectTagsData = (state) => state.settings.simulator.self.tags
const selectCandidatesData = (state) => state.settings.simulator.self.candidates
const selectTags = createSelector(selectTagsData, (tags) =>
  tags.data.reduce((acc, elem) => {
    if (elem.id !== -1) {
      acc.push({ value: elem.id, label: elem.name })
    }

    return acc
  }, [])
)
const selectCandidates = createSelector(selectCandidatesData, (candidates) =>
  candidates.data.items.map(({ id, fullName, type }) => ({
    label: fullName,
    value: id,
    type,
  }))
)

export {
  selectData,
  selectLoader,
  selectError,
  selectRecipientList,
  selectTags,
  selectTagsData,
  selectCandidates,
  selectCandidatesData,
}
